<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fWPel/vinc_9781590208007_msr_cvi_r1.jpg?1696093349468" alt="This image is the cover for the book Into Temptation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Into Temptation
      </h1>
      <p class="bookDescription body article font2">
        <b>A widowed matriarch’s well-to-do English family is rocked by her plan to remarry in this “page-turner” from the bestselling author of <i>No Angel</i> (<i>Publishers Weekly</i>).</b><br/><br/>Rescued from the slums as a baby by Celia Lytton and now living in New York, Barty Miller heads more than half of the Lyttons publishing house. But as they fall on bad times in the years after World War II, the family is worried that Barty will make a business decision that would be devastating to them. But will she? As events unfold, long-buried secrets concerning the whole family are revealed—and Celia makes a shocking announcement that she is leaving the company and getting remarried—shaking the very foundations of the Lyttons’ world . . . <br/><br/>“Vincenzi writes . . . fast-paced novels with plots and subplots so deftly manipulated that it’s impossible to start reading one and still lead a productive life.” —<i>The Washington Post</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Penny Vincenzi
      </h2>
      
      <p class="authorDescription body article">Penny Vincenzi has written seventeen bestselling novels, including No Angel, Something Dangerous, Into Temptation, Wicked Pleasures, Another Woman, Forbidden Places, Windfall, An Outrageous Affair, The Dilemma, Almost a Crime, and A Perfect Heritage. Before becoming a novelist, she worked at such magazines as Vogue, Tatler, and Cosmopolitan. She has four daughters, and divides her time between London and Gower, South Wales. Over seven million copies of her books have been sold worldwide.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PENGUIN group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8ffde34c